import { useState } from "react";
import { PATHS } from "../../config/permissionsPaths";
import useAuth from "../../hooks/useAuth";
import {
  FranjaTitle,
  Sidebar,
  CalcList,
  CalcItem,
  MainPanel,
  ViewWrapper,
} from "./Masters.style";

//administrador
import Users from "./components/admin/Users";
import AccessLevel from "./components/admin/AccessLevel";
import Empresa from "./components/admin/Empresa";
import Sede from "./components/admin/Sede";
import ReportManager from "./components/admin/ReportManager";
import HomologacionValor from "./components/admin/HomologacionValor";
import CalculadorasDinamicas from "./components/admin/CalculadorasDinamicas";

//parametrizacion
import Routes from "./components/parameterization/Route";
import Groups from "./components/parameterization/Group";
import SubGroups from "./components/parameterization/Subgroup";
import Consecutivo from "./components/parameterization/Consecutivo";
import RoutePYM from "./components/parameterization/RoutePYM";
import RiskQuestions from "./components/parameterization/RiskQuestions";
import ExcludedQuestionsBySubgroup from "./components/parameterization/ExcludedQuestionsBySubgroup";
import ExcludedActivitiesBySubgroup from "./components/parameterization/ExcludedActivitiesBySubgroup";
import AyudasISA from "./components/parameterization/AyudasISA";
import ValoresNormales from "./components/parameterization/ValoresNormales";
import Codificacion from "./components/parameterization/Codificacion";

export default function Masters() {
  const [open, setOpen] = useState({
    parametrizacion: false,
    admin: false,
  });

  const [selectedView, setSelectedView] = useState(null);

  const views = {
    users: <Users />,
    access: <AccessLevel />,
    empresa: <Empresa />,
    sede: <Sede />,
    reportManager: <ReportManager />,
    homologacionValor: <HomologacionValor />,
    calculadorasDinamicas: <CalculadorasDinamicas />,
    routes: <Routes />,
    groups: <Groups />,
    subgroups: <SubGroups />,
    cons: <Consecutivo />,
    routesPYM: <RoutePYM />,
    riskquestion: <RiskQuestions />,
    excludedQuestionsBySubgroup: <ExcludedQuestionsBySubgroup />,
    excludedActivitiesBySubgroup: <ExcludedActivitiesBySubgroup />,
    ayudas: <AyudasISA />,
    valoresNormales: <ValoresNormales />,
    codificacion: <Codificacion />,
  };

  const { hasPermission } = useAuth();

  return (
    <div className="div-container">
      <Sidebar>
        <FranjaTitle>MAESTROS</FranjaTitle>
        <CalcList>
          {hasPermission(PATHS.RUTA) && (
            <CalcItem
              onClick={() =>
                setOpen({ ...open, parametrizacion: !open.parametrizacion })
              }
            >
              {" "}
              Parametrización {open.parametrizacion ? "▲" : "▼"}{" "}
            </CalcItem>
          )}
          {open.parametrizacion && (
            <>
              {hasPermission(PATHS.RUTA) && (
                <CalcItem
                  style={{ marginLeft: "20px" }}
                  active={selectedView === "routes"}
                  onClick={() => setSelectedView("routes")}
                >
                  {" "}
                  Rutas{" "}
                </CalcItem>
              )}
              {hasPermission(PATHS.GRUPO) && (
                <CalcItem
                  style={{ marginLeft: "20px" }}
                  active={selectedView === "groups"}
                  onClick={() => setSelectedView("groups")}
                >
                  {" "}
                  Grupos{" "}
                </CalcItem>
              )}
              {hasPermission(PATHS.SUBGRUPO) && (
                <CalcItem
                  style={{ marginLeft: "20px" }}
                  active={selectedView === "subgroups"}
                  onClick={() => setSelectedView("subgroups")}
                >
                  {" "}
                  SubGrupos{" "}
                </CalcItem>
              )}
              {hasPermission(PATHS.CONSECUTIVO) && (
                <CalcItem
                  style={{ marginLeft: "20px" }}
                  active={selectedView === "cons"}
                  onClick={() => setSelectedView("cons")}
                >
                  {" "}
                  Consecutivos{" "}
                </CalcItem>
              )}
              {hasPermission(PATHS.RUTASPYM) && (
                <CalcItem
                  style={{ marginLeft: "20px" }}
                  active={selectedView === "routesPYM"}
                  onClick={() => setSelectedView("routesPYM")}
                >
                  {" "}
                  Rutas PYM{" "}
                </CalcItem>
              )}
              {hasPermission(PATHS.PREGUNTARIESGO) && (
                <CalcItem
                  style={{ marginLeft: "20px" }}
                  active={selectedView === "riskquestion"}
                  onClick={() => setSelectedView("riskquestion")}
                >
                  {" "}
                  Pregunta Riesgo{" "}
                </CalcItem>
              )}
              {hasPermission(PATHS.PREGUNTASEXCLUIDASSUBGRUPO) && (
                <CalcItem
                  style={{ marginLeft: "20px" }}
                  active={selectedView === "excludedQuestionsBySubgroup"}
                  onClick={() => setSelectedView("excludedQuestionsBySubgroup")}
                >
                  {" "}
                  Preguntas excluidas por subgrupo{" "}
                </CalcItem>
              )}
              {hasPermission(PATHS.ACTIVIDADESEXCLUIDASSUBGRUPO) && (
                <CalcItem
                  style={{ marginLeft: "20px" }}
                  active={selectedView === "excludedActivitiesBySubgroup"}
                  onClick={() => setSelectedView("excludedActivitiesBySubgroup")}
                >
                  {" "}
                  Actividades excluidas por subgrupo{" "}
                </CalcItem>
              )}
              {hasPermission(PATHS.GRUPO) && (
                <CalcItem
                  style={{ marginLeft: "20px" }}
                  active={selectedView === "ayudas"}
                  onClick={() => setSelectedView("ayudas")}
                >
                  {" "}
                  Ayudas ISA{" "}
                </CalcItem>
              )}
              {(!PATHS.VALORES_NORMALES || hasPermission(PATHS.VALORES_NORMALES) || hasPermission(PATHS.CONSECUTIVO)) && (
                <CalcItem
                  style={{ marginLeft: "20px" }}
                  active={selectedView === "valoresNormales"}
                  onClick={() => setSelectedView("valoresNormales")}
                >
                  {" "}
                  Valores Normales{" "}
                </CalcItem>
              )}
              {(!PATHS.CODIFICACION || hasPermission(PATHS.CODIFICACION) || hasPermission(PATHS.CONSECUTIVO)) && (
                <CalcItem
                  style={{ marginLeft: "20px" }}
                  active={selectedView === "codificacion"}
                  onClick={() => setSelectedView("codificacion")}
                >
                  {" "}
                  Codificación{" "}
                </CalcItem>
              )}
            </>
          )}

          <CalcItem onClick={() => setOpen({ ...open, admin: !open.admin })}>
            {" "}
            Admin {open.admin ? "▲" : "▼"}{" "}
          </CalcItem>

          {open.admin && (
            <>
              {hasPermission(PATHS.USUARIOS) && (
                <CalcItem style={{ marginLeft: "20px" }} active={selectedView === "users"} onClick={() => setSelectedView("users")}>
                  {" "}Usuarios{" "}
                </CalcItem>
              )}
              {hasPermission(PATHS.PERMISOS) && (
                <CalcItem style={{ marginLeft: "20px" }} active={selectedView === "access"} onClick={() => setSelectedView("access")}>
                  {" "}Niveles de acceso{" "}
                </CalcItem>
              )}
              {hasPermission(PATHS.EMPRESAS) && (
                <CalcItem style={{ marginLeft: "20px" }} active={selectedView === "empresa"} onClick={() => setSelectedView("empresa")}>
                  {" "}Empresas{" "}
                </CalcItem>
              )}
              {hasPermission(PATHS.SEDES) && (
                <CalcItem style={{ marginLeft: "20px" }} active={selectedView === "sede"} onClick={() => setSelectedView("sede")}>
                  {" "}Sedes{" "}
                </CalcItem>
              )}
              {hasPermission(PATHS.REPORTES) && (
                <CalcItem style={{ marginLeft: "20px" }} active={selectedView === "reportManager"} onClick={() => setSelectedView("reportManager")}>
                  {" "}Configuración de Reportes{" "}
                </CalcItem>
              )}
              {hasPermission(PATHS.CALCULADORAS_DINAMICAS) && (
                <CalcItem style={{ marginLeft: "20px" }} active={selectedView === "calculadorasDinamicas"} onClick={() => setSelectedView("calculadorasDinamicas")}>
                  {" "}Calculadoras dinámicas{" "}
                </CalcItem>
              )}
              <CalcItem style={{ marginLeft: "20px" }} active={selectedView === "homologacionValor"} onClick={() => setSelectedView("homologacionValor")}>
                {" "}Homologación Valores{" "}
              </CalcItem>
            </>
          )}
        </CalcList>
      </Sidebar>

      <MainPanel>
        {selectedView ? (
          <ViewWrapper>{views[selectedView]}</ViewWrapper>
        ) : (
          <h2>Selecciona una opción del menú</h2>
        )}
      </MainPanel>
    </div>
  );
}
